import React, {useEffect, useState} from 'react';

import {
  Container,
  Icon,
  Store,
  StoreAddress,
  AddressText,
  StoreColumn,
  StoreContent,
  StoreDetails,
  StoreDistance,
  DistanceBadge,
  StoreImage,
  StoreInfos,
  StoreMeta,
  StoreName,
} from './styles';
import {UnidadeDTO} from '../../../../dtos/ParceiroDTO';
import {useNavigation} from '@react-navigation/native';
import {useLocalization} from '../../../../context/localization';

import * as geolib from 'geolib';
import {RFValue} from 'react-native-responsive-fontsize';

interface Props {
  data: UnidadeDTO;
  logoImageUrl: string;
  showDivisor?: boolean;
}

export function StoreUnitItem({data, logoImageUrl, showDivisor}: Props) {
  const navigation = useNavigation();

  const {position} = useLocalization();
  const [storeDistance, setStoreDistance] = useState('');

  const LAT = parseFloat(data.endereco.geolocalizacao.latitude);
  const LNG = parseFloat(data.endereco.geolocalizacao.longitude);

  function getDistance() {
    if (position) {
      const distance = geolib
        .convertDistance(
          geolib.getDistance(
            {
              latitude: position.latitude,
              longitude: position.longitude,
            },
            {
              latitude: LAT,
              longitude: LNG,
            },
          ),
          'km',
        )
        .toFixed(1);

      setStoreDistance(distance);
    }
  }

  useEffect(() => {
    getDistance();
  }, []);

  useEffect(() => {
    getDistance();
  }, [position]);

  return (
    <Container
      style={{
        marginTop: showDivisor ? RFValue(10) : 0,
      }}>
      <Store
        activeOpacity={0.7}
        onPress={() =>
          navigation.navigate('UnitsDetails', {data, image: logoImageUrl})
        }>
        <StoreContent>
          <StoreColumn>
            <StoreImage source={{uri: logoImageUrl}} resizeMode="contain" />

            <StoreInfos>
              <StoreDetails>
                <StoreAddress>
                  {data.endereco.cidade && data.endereco.cidade.nome     ? data.endereco.cidade.nome : "Desconhecido"} - {data.endereco.estado.uf}
                </StoreAddress>
              </StoreDetails>
              <StoreName numberOfLines={2}>{data.nome}</StoreName>
              <StoreMeta>
                {data.endereco.resumo && (
                  <AddressText numberOfLines={1}>
                    {data.endereco.resumo}
                  </AddressText>
                )}
                {storeDistance.length > 0 && (
                  <DistanceBadge>
                    <StoreDistance>{storeDistance} km</StoreDistance>
                  </DistanceBadge>
                )}
              </StoreMeta>
            </StoreInfos>
          </StoreColumn>

          <Icon name="chevron-right" />
        </StoreContent>
      </Store>
    </Container>
  );
}
